/*
 * Copyright (C) 2023 to Present Applause App Quality, Inc. All rights reserved.
 */

import { InjectionToken } from '@angular/core';

export interface NgfTooltipStyles {
  readonly maxWidth?: string | null;
  readonly textAlign?: string | null;
}

export const NGF_TOOLTIP_STYLES = new InjectionToken<NgfTooltipStyles | null>('Ngf Tooltip Styles');
